import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProfileDetail } from "../types";

export const getProfileDetailRequest = (billingProfileId: string) => {
  return apiProxyRequest<ProfileDetail>(
    `/billing/profiles/${billingProfileId}`
  );
};
